import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import { Link } from 'react-router-dom'


function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const PermissionModal = ({ open, error, handleClose, link }) =>
    <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
    >
        <DialogTitle id="alert-dialog-slide-title">
            Permission Denied.
          </DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
                {error}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} color="primary">
                Cancel
            </Button>
            {link}
        </DialogActions>
    </Dialog>

export default PermissionModal
